import React from "react";
import { useLanguage } from "@/lib/i18n";
import { Globe } from "lucide-react";

/**
 * FR / EN segmented switcher (live language toggle).
 */
export default function LanguageSwitcher({ tone = "auto" }) {
  const { lang, setLang } = useLanguage();

  const baseClass =
    tone === "dark"
      ? "text-white/85 border-white/25 hover:border-white/60"
      : "text-ink/85 border-ink/15 hover:border-ink/40";

  return (
    <div className="relative inline-flex items-center" data-testid="language-switcher">
      <div className={`flex items-center gap-0.5 border ${baseClass} rounded-full px-1 py-1 transition-colors`}>
        <Globe size={13} className="mx-1.5 opacity-60" />
        {[
          { code: "fr", label: "FR" },
          { code: "en", label: "EN" },
        ].map((o) => {
          const active = lang === o.code;
          return (
            <button
              key={o.code}
              type="button"
              onClick={() => setLang(o.code)}
              data-testid={`lang-${o.code}`}
              aria-label={`Switch to ${o.label}`}
              className={`px-2.5 py-1 text-[11px] font-bold tracking-[0.15em] rounded-full transition-all ${
                active ? "bg-brand text-white shadow-sm" : "opacity-60 hover:opacity-100"
              }`}
            >
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

